var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({staticClass:"app-input",class:{ 'app-input--error': _vm.isError },on:{"input":_vm.onInput,"chage":_vm.onChange}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }